module.exports = __webpack_public_path__ + "img/02.4053a8a9.jpg";